<template>
  <v-dialog v-model="show" max-width="800px">
    <v-card>
      <v-card-title>
        Laporan Kuesioner
        <v-spacer></v-spacer>
        <VBtn
          prepend-icon="ri-refresh-line"
          class="me-4"
          color="primary"
          @click="checkStatus"
        >
          Cek Status
        </VBtn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="list_data"
        :options.sync="options"
        :server-items-length="totalData"
        :loading="loading"
        class="elevation-1"
      >
        <template #[`item.link`]="{ item }">
          <a
            v-if="item.state == 'completed'"
            :href="item.base_file_url + item.data.file_name"
            target="_blank"
            rel="noopener noreferrer"
          >
            Link
          </a>
        </template>

        <template #[`item.created_on`]="{ item }">
          {{ getCurrentDate(item.created_on) }}
        </template>

        <template #[`item.state`]="{ item }">
          <div class="d-flex align-center">
            <VChip
              v-if="item.state == 'active' || item.state == 'created'"
              :color="getColor(item.state)"
              size="small"
              class="text-capitalize"
              style="color: white"
            >
              processing
            </VChip>
            <VChip
              v-else
              :color="getColor(item.state)"
              size="small"
              class="text-capitalize"
              style="color: white"
            >
              {{ item.state }}
            </VChip>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="show = false"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import LaporanService from "../../services/PsikologisHasilService";
import moment from "moment";

const props = defineProps({
  value: Boolean,
});

const emit = defineEmits(["input", "pilihAnggota"]);

// Menggantikan 'data' dengan 'ref' untuk reaktivitas
const headers = [
  { text: "No", align: "start", sortable: false, value: "no" },
  { text: "Status Report", value: "state", sortable: false },
  { text: "Tanggal", value: "created_on", sortable: false },
  { text: "Link Download", value: "link", sortable: false },
];
const totalData = ref(0);
const list_data = ref([]);
const loading = ref(true);
const options = ref({ page: 1, itemsPerPage: 5 });

// Menggantikan 'computed'
const show = computed({
  get: () => props.value,
  set: (val) => emit("input", val),
});

// Menggantikan 'methods' dengan fungsi biasa
const getDataFromApi = () => {
  const { page, itemsPerPage } = options.value;
  loading.value = true;

  LaporanService.getListLaporan(page, itemsPerPage)
    .then((res) => {
      list_data.value = res.data.list_data;
      totalData.value = parseInt(res.data.total, 10);
      loading.value = false;
    })
    .catch((err) => {
      loading.value = false;
      console.error(err);
    });
};

const getColor = (status) => {
  switch (status) {
    case "active":
    case "created":
      return "orange";
    case "completed":
      return "green";
    case "failed":
      return "red";
    default:
      return "primary";
  }
};

const checkStatus = () => {
  getDataFromApi();
};

const getCurrentDate = (tanggal) => {
  return moment(tanggal).format("DD/MM/YYYY HH:mm");
};

// Menggantikan 'watch'
watch(options, getDataFromApi, { deep: true });

// Menggantikan 'mounted'
onMounted(() => {
  getDataFromApi();
});

defineExpose({
  getDataFromApi,
});
</script>

<style scoped>
.loader {
  text-align: center;
  color: #bbbbbb;
}
</style>
